import React, { useState } from 'react';
import { PATENTS } from '../constants';
import { Award, ExternalLink, ChevronDown, ChevronUp } from 'lucide-react';

const PatentList: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Show 3 initially, then all
  const displayedPatents = isExpanded ? PATENTS : PATENTS.slice(0, 3);
  const hasMore = PATENTS.length > 3;

  return (
    <div className="space-y-6">
      <div className="grid gap-6">
        {displayedPatents.map((patent, index) => (
          <div 
            key={index} 
            className={`group bg-white border border-gray-100 p-6 md:p-8 rounded-2xl hover:border-gray-300 transition-all duration-300 hover:shadow-sm flex flex-col md:flex-row gap-6 items-start md:items-center justify-between ${index >= 3 ? 'animate-in fade-in slide-in-from-top-4 duration-500' : ''}`}
          >
            <div className="flex gap-4">
              <div className="flex-shrink-0 mt-1">
                <Award className="text-gray-300 group-hover:text-yellow-500 transition-colors" size={24} />
              </div>
              <div>
                 <div className="flex items-center gap-3 mb-2">
                   <span className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded border ${patent.status === 'Granted' ? 'bg-green-50 text-green-700 border-green-100' : 'bg-blue-50 text-blue-700 border-blue-100'}`}>
                     {patent.status}
                   </span>
                   <span className="text-xs text-gray-400 font-mono">{patent.date}</span>
                 </div>
                 <h3 className="font-semibold text-gray-900 text-lg mb-1 group-hover:text-blue-600 transition-colors leading-snug">
                   {patent.title}
                 </h3>
                 <p className="text-sm text-gray-500">
                   Assignee: {patent.assignee} • No: {patent.number}
                 </p>
              </div>
            </div>
            
            {patent.link && (
              <a 
                href={patent.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 px-4 py-2 border border-gray-200 text-sm font-medium rounded-lg text-gray-600 hover:text-gray-900 hover:border-gray-900 transition-colors flex items-center gap-2"
              >
                View Patent
                <ExternalLink size={14} />
              </a>
            )}
          </div>
        ))}
      </div>

      {hasMore && (
        <div className="text-center mt-8">
          <button 
            onClick={() => setIsExpanded(!isExpanded)}
            className="inline-flex items-center gap-2 px-8 py-3 bg-white border border-gray-200 rounded-full text-sm font-bold text-gray-600 hover:border-gray-900 hover:text-gray-900 transition-all shadow-sm hover:shadow-md active:scale-95 group"
          >
            {isExpanded ? (
              <>Show Less <ChevronUp size={16} className="group-hover:-translate-y-0.5 transition-transform" /></>
            ) : (
              <>Show All Patents ({PATENTS.length}) <ChevronDown size={16} className="group-hover:translate-y-0.5 transition-transform" /></>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default PatentList;